import {
  ADDRESERVATION,
  RESERVATION,
  RESERVATION_DETAILS,
  RESERVEBY,
  RESERVE_BY_DETAILS,
  SOURCE,
  SOURCE_BY_DETAILS,
  LIST_WALKIN,
  LIST_WALKIN_DETAILS,
  LIST_WAITING,
  LIST_WAITING_DETAILS,
  LIST_HISTORY_RESERVATION ,
  LIST_HISTORY_RESERVATION_DETAILS,
  GET_USER_PHONE_DETAILS,
  LIST_DELETED_RESERVATION,
  DELETED_RESERVATION_DETAILS,
} from "redux/constants/ReservationConstants";
import { AUTH_TOKEN } from "../constants/Auth";

const initState = {
  loading: true,
  message: "",
  redirect: "",
  showMessage: false,
  token: localStorage.getItem(AUTH_TOKEN),
  data: "",
};

const ReservationReducer = (state = initState, action) => {
  // console.log(...state);
  switch (action.type) {
    case ADDRESERVATION:
      return {
        ...state,
        loading:false,

        redirect: "",
        token: action.token,
        reservationData: action.reservationData,
      };
    case RESERVATION:
      return {
        ...state,
        redirect: "",
        loading:true,
        token: action.token,
        reservationData: action.payload,
      };
    case RESERVATION_DETAILS: {
      return {
        ...state,
        redirect: "",
        loading:false,

        reservationData: action.payload,
        token: action.token,
      };
    }

    case RESERVEBY: {
      return {
        ...state,
        redirect: "",
        loading:true,

        // token: action.token,
        reservebyData: action.payload,
      };
    }
    case RESERVE_BY_DETAILS: {
      return {
        ...state,
        redirect: "",
        loading:false,

        reservebyData: action.payload,
        // token: action.token,
      };
    }

    case SOURCE: {
      return {
        ...state,
        redirect: "",
        loading:true,

        // token: action.token,
        sourcebyData: action.payload,
      };
    }

    case SOURCE_BY_DETAILS: {
      return {
        ...state,
        redirect: "",
        loading:false,

        sourcebyData: action.payload,
        // token: action.token,
      };
    }

    case LIST_WALKIN: {
      return {
        ...state,
        redirect: "",
        loading:true,

        // token: action.token,
        walkinData: action.payload,
      };
    }
    case LIST_WALKIN_DETAILS: {
      return {
        ...state,
        redirect: "",
        loading:false,

        walkinData: action.payload,
        // token: action.token,
      };
    }

    case LIST_WAITING: {
      return {
        ...state,
        redirect: "",
        loading:true,

        // token: action.token,
        waitingData: action.payload,
      };
    }
    case LIST_WAITING_DETAILS: {
      return {
        ...state,
        redirect: "",
        loading:false,

        waitingData: action.payload,
        // token: action.token,
      };
    }
    case LIST_HISTORY_RESERVATION_DETAILS: {
      return {
        ...state,
        loading:false,
        redirect: "",
        historyReservation: action.payload,
        // token: action.token,
      };
    }

    case GET_USER_PHONE_DETAILS: {
      return {
        ...state,
        redirect: "",
        name: action.payload,
        // token: action.token,
      };
    }

    case LIST_DELETED_RESERVATION: {
      return {
        ...state,
        loading:true,

        redirect: "",
        // token: action.token,
        deletedData: action.payload,
      };
    }
    case DELETED_RESERVATION_DETAILS: {
      return {
        ...state,
        redirect: "",
        deletedData: action.payload,
        // token: action.token,
        loading:false,

      };
    }
    case LIST_HISTORY_RESERVATION: {
      return {
        ...state,
        loading:true,
        redirect: "",
        // token: action.token,
        deletedData: action.payload,
      };
    }
    
    default:
      return state;
  }
};

export default ReservationReducer;
